import React from "react";
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { StaffMember } from "src/shared/services/interfacev2";

interface StaffFilterProps {
  staffList: StaffMember[];
  selectedStaff: string;
  onStaffChange: (value: string) => void;
}

const StaffFilter: React.FC<StaffFilterProps> = ({ staffList, selectedStaff, onStaffChange }) => {
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 40 * 6.5,
        borderRadius: "8px",
      },
    },
  };

  return (
    <FormControl fullWidth size="small" variant="outlined">
      <InputLabel id="staff-label">Staff</InputLabel>

      <Select
  labelId="staff-label"
  label="Staff"
  value={selectedStaff}
  onChange={(e: SelectChangeEvent<string>) =>
    onStaffChange(e.target.value)
  }
  className="rounded-xl"
  MenuProps={MenuProps}
>
  <MenuItem value="">All Staff</MenuItem>

  {staffList
    ?.filter(Boolean)
    .map((staff) => (
      <MenuItem key={staff._id?.$oid} value={staff._id?.$oid}>
        {[staff.firstName, staff.middleName, staff.lastName]
          .filter(Boolean)
          .join(" ")}
      </MenuItem>
    ))}
</Select>
    </FormControl>
  );
};

export default StaffFilter;
